/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccessRestriction,
    AccessRestrictionFromJSON,
    AccessRestrictionFromJSONTyped,
    AccessRestrictionToJSON,
} from './AccessRestriction';
import {
    AppAssociation,
    AppAssociationFromJSON,
    AppAssociationFromJSONTyped,
    AppAssociationToJSON,
} from './AppAssociation';
import {
    OnboardingPublishActions,
    OnboardingPublishActionsFromJSON,
    OnboardingPublishActionsFromJSONTyped,
    OnboardingPublishActionsToJSON,
} from './OnboardingPublishActions';
import {
    Organization,
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
} from './Organization';
import {
    OrganizationType,
    OrganizationTypeFromJSON,
    OrganizationTypeFromJSONTyped,
    OrganizationTypeToJSON,
} from './OrganizationType';

/**
 * 
 * @export
 * @interface OnboardingPublishAction
 */
export interface OnboardingPublishAction {
    /**
     * The organization's unique identifier.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    organizationId: string;
    /**
     * 
     * @type {OrganizationType}
     * @memberof OnboardingPublishAction
     */
    organizationType: OrganizationType;
    /**
     * The name of the organization.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    name: string;
    /**
     * An icon URL for the organization. A square 128px x 128px.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    iconUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    timezone?: string;
    /**
     * The preferred locale used for communication, in BCP 47 format.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    locale?: string;
    /**
     * The portal admin owner unique identifier. The owner is an administrator that cannot be removed or altered by other portal admins.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    ownerId: string;
    /**
     * 
     * @type {AccessRestriction}
     * @memberof OnboardingPublishAction
     */
    accessRestriction?: AccessRestriction;
    /**
     * 
     * @type {AppAssociation}
     * @memberof OnboardingPublishAction
     */
    appAssociation?: AppAssociation;
    /**
     * How a client should handle a successful request.
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    action: OnboardingPublishActionActionEnum;
    /**
     * If action=REDIRECT_URL, the client should redirect to this URL
     * @type {string}
     * @memberof OnboardingPublishAction
     */
    actionUrl?: string;
}


/**
 * @export
 */
export const OnboardingPublishActionActionEnum = {
    RedirectPortal: 'REDIRECT_PORTAL',
    RedirectUrl: 'REDIRECT_URL',
    PageDownloads: 'PAGE_DOWNLOADS'
} as const;
export type OnboardingPublishActionActionEnum = typeof OnboardingPublishActionActionEnum[keyof typeof OnboardingPublishActionActionEnum];


export function OnboardingPublishActionFromJSON(json: any): OnboardingPublishAction {
    return OnboardingPublishActionFromJSONTyped(json, false);
}

export function OnboardingPublishActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingPublishAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'organizationType': OrganizationTypeFromJSON(json['organizationType']),
        'name': json['name'],
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
        'timezone': !exists(json, 'timezone') ? undefined : json['timezone'],
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'ownerId': json['ownerId'],
        'accessRestriction': !exists(json, 'accessRestriction') ? undefined : AccessRestrictionFromJSON(json['accessRestriction']),
        'appAssociation': !exists(json, 'appAssociation') ? undefined : AppAssociationFromJSON(json['appAssociation']),
        'action': json['action'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
    };
}

export function OnboardingPublishActionToJSON(value?: OnboardingPublishAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organizationId': value.organizationId,
        'organizationType': OrganizationTypeToJSON(value.organizationType),
        'name': value.name,
        'iconUrl': value.iconUrl,
        'timezone': value.timezone,
        'locale': value.locale,
        'ownerId': value.ownerId,
        'accessRestriction': AccessRestrictionToJSON(value.accessRestriction),
        'appAssociation': AppAssociationToJSON(value.appAssociation),
        'action': value.action,
        'actionUrl': value.actionUrl,
    };
}

